import { dissoc } from 'ramda'

import { ApiFunc, getInstance } from '../../../helpers/httpClient'
import * as API from '../constants/api'

const instance = getInstance()

export const chatGroupByComponent: ApiFunc<`${typeof API.CHAT_GROUP_BY_COMPONENT}`, 'get'> = data =>
  instance.get(API.CHAT_GROUP_BY_COMPONENT, {
    params: data,
  })

export const chatGroupCreate: ApiFunc<`${typeof API.CHAT_GROUP}`, 'post'> = data => instance.post(API.CHAT_GROUP, data)

export const chatGroupById: ApiFunc<`${typeof API.CHAT_GROUP}{id}`, 'get'> = data =>
  instance.get(`${API.CHAT_GROUP}${'id' in data ? data.id : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const chatGroupDeactivate: ApiFunc<`${typeof API.CHAT_GROUP_DEACTIVATE}{id}`, 'put'> = data =>
  instance.put(`${API.CHAT_GROUP_DEACTIVATE}${'id' in data ? data.id : data.name}`)

export const messagesGroup: ApiFunc<`${typeof API.MESSAGES_GROUP}`, 'get'> = data =>
  instance.get(API.MESSAGES_GROUP, { params: data })

export const messagesGroupAll: ApiFunc<`${typeof API.MESSAGES_GROUP_ALL}`, 'get'> = data =>
  instance.get(API.MESSAGES_GROUP_ALL, { params: data })
